import { render, staticRenderFns } from "./MdElementForm.vue?vue&type=template&id=5a722822&scoped=true&"
import script from "./MdElementForm.vue?vue&type=script&lang=js&"
export * from "./MdElementForm.vue?vue&type=script&lang=js&"
import style0 from "./MdElementForm.vue?vue&type=style&index=0&id=5a722822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a722822",
  null
  
)

export default component.exports